export function sortArrayByProperty<T extends Record<PropertyKey, string>>(
  arrayToSort: readonly T[],
  property: keyof T,
) {
  return [...arrayToSort].sort((a, b) => a[property].localeCompare(b[property]));
}
